import {authHeaders, handleResponse} from "./apiUtils";

const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

async function getClientNotificationHistory(clientId) {
  const query = `?recipientType=client&recipientId=${encodeURIComponent(clientId)}`;
  const response = await fetch(`${baseUrl}notifications${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

export default { getClientNotificationHistory };
